<template>
    <div class="paper-content">
        <div class="add-btn">
            <el-button type="primary" @click="createTemp()">
                <i class="el-icon-plus" style="margin-right: 5px"></i>创建概率模板
            </el-button>
        </div>
        <el-table :data="paperData" height="1%" size="medium"
                  :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#F6F6F6', height:'60px'}"
                  class="customTable" :cell-style="{fontSize: '16px',color: '#333', height:'70px'}">
            <el-table-column label="概率模板名称">
                <template slot-scope="scope">
                    <span class="text-overflow-2" :title="scope.row.paper_per_group_name">{{ scope.row.paper_per_group_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-switch
                            v-model="scope.row.status"
                            active-color="#EEEEEE"
                            inactive-color="#F23B2F"
                            :active-value="0"
                            :inactive-value="1"
                            @change="changeSwitch(scope.row,scope.$index)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <div class="link-box">
                        <el-link :underline="false" type="success" @click="editCourse(scope.row, scope.$index)">编辑
                        </el-link>
                        <el-link :underline="false" type="danger"
                                 @click="deleteRow(scope.$index, scope.row)">删除
                        </el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <pagination class="pages-center" :total="total" @current-change="CurrentChange">
        </pagination>
    </div>
</template>

<script>
    import pagination from 'components/pagination.vue';
    import {probabilityGetList, probabilityOpen, probabilityClose, probabilityDel} from "@/utils/apis";

    export default {
        name: "Index",
        components: {
            pagination
        },
        data() {
            return {
                paperData: [],
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            }
        },
        created() {
            this.getList();
        },
        methods: {
            getList() {
                let param = {
                    page: this.currentPageNum,
                    paging: 1,
                    pageSize: this.eachPageNum
                }
                probabilityGetList(param).then((res) => {
                    if (res.code == 200) {
                        this.paperData = res.data.list;
                    } else {
                        this.$message.warning(res.msg)
                    }
                }).catch((err) => {
                    console.error('err', err);
                })
            },
            changeSwitch(row, index) {
                let openedIndex = null;
                let opened_id = '';
                if (row.status == 1) {
                    this.paperData.forEach((item, $index) => {
                        if ($index != index && item.status == 1) {
                            openedIndex = $index
                            opened_id = item.paper_per_group_id
                        }
                    })
                    //如果有已经开启的，先关闭已开启的
                    if (openedIndex != null) {
                        let closeParam = {
                            paper_per_group_id: opened_id
                        }
                        probabilityClose(closeParam).then((res) => {
                            if (res.code == 200) {
                                this.openTemp(row)
                            }
                        }).catch((err) => {
                            console.error(err)
                        })
                    } else {
                        this.openTemp(row)
                    }
                } else {
                    let closeParam = {
                        paper_per_group_id: row.paper_per_group_id
                    }
                    probabilityClose(closeParam).then((res) => {
                        if (res.code == 200) {
                            this.$message.success(res.msg)
                            this.getList()
                        }
                    }).catch((err) => {
                        console.error(err)
                    })
                }
            },
            openTemp(row) {
                let openParam = {
                    paper_per_group_id: row.paper_per_group_id
                }
                probabilityOpen(openParam).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getList()
                    }
                }).catch((err) => {
                    console.error(err)
                })
            },
            createTemp() {
                this.$router.push('/paperProbability/create')
            },
            CurrentChange(val) {
                this.currentPageNum = val;
                this.getList()
            },
            editCourse(row, index) {
                this.$router.push({
                    path: '/paperProbability/create',
                    query: {
                        id: row.paper_per_group_id
                    }
                })
            },
            deleteRow(index, row) {
                this.$confirm(`是否删除该模板，删除将无法恢复`, '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: "green-message-box",
                    type: 'warning'
                }).then(() => {
                    let param = {
                        paper_per_group_id: row.paper_per_group_id
                    }
                    probabilityDel(param).then((res) => {
                        if (res.code == 200) {
                            this.$message.success(res.msg)
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
        }
    }
</script>

<style scoped lang="scss">
    .paper-content {
        height: 100%;
        padding: 0 20px;
        display: flex;
        flex-direction: column;

        .add-btn {
            margin: 15px 0;
            height: 40px;
            text-align: right;
        }

        .customTable {
            width: 100%;
            flex: 1;

            .link-box {
                height: 16px;
                display: flex;
                justify-content: center;
            }
        }
    }
</style>